import { tApi } from 'tplus-api';

export default class PickUpApi {
    /**
     * 
     * @param {*} LadingCode
     */
    static async getPickUpData(LadingCode,dto) { 
        return await tApi({ 'LadingCode': LadingCode,"Retail":dto}, 'chanjet.RE.INewRetail.PickUp', false, false);
    }
}